export namespace PricingSearchList {
    export const citizenshipList = [
        { ID: 'USCitizen', Display: 'U.S. Citizen' },
        { ID: 'USCitizenAbroad', Display: 'US Citizen Abroad' },
        { ID: 'ForeignNational', Display: 'Foreign National' },
        { ID: 'PermResidentAlien', Display: 'Perm. Resident Alien' },
        { ID: 'NonPermResidentAlien', Display: 'Non-Perm. Resident Alien' },
    ];

    export const monthsReserves = [
        { ID: 0, Display: 'None' },
        { ID: 3, Display: '3 Months' },
        { ID: 6, Display: '6 months' },
        { ID: 12, Display: '12 months' },
        { ID: 18, Display: '18 months' },
        { ID: 24, Display: '24 months' }
    ];

    export const doctTypeList = [
        { ID: 'FullDoc', Display: 'Full Doc' },
        { ID: 'PersonalBankStmt12Mos', Display: '12Mo Personal Bank Statements' },
        { ID: 'PersonalBankStmt18Mos', Display: '18Mo Personal Bank Statements' },
        { ID: 'PersonalBankStmt24Mos', Display: '24Mo Personal Bank Statements' },
        { ID: 'BusinessBankStmt12Mos', Display: '12Mo Business Bank Statements' },
        { ID: 'BusinessBankStmt18Mos', Display: '18Mo Business Bank Statements' },
        { ID: 'BusinessBankStmt24Mos', Display: '24Mo Business Bank Statements' },
        { ID: 'OneYearAltDoc', Display: '12Mo Alt Doc' },
        { ID: 'AssetRelated', Display: 'Asset Related' },
        { ID: 'InvestorDscr', Display: 'Investor DSCR' },
        { ID: 'RestrictedStock', Display: 'Restricted Stock' },
        { ID: 'InvestorNoRatio', Display: 'Investor No Ratio' },
        { ID: 'TwoYearAltDoc', Display: '24Mo Alt Doc' },
        { ID: 'WrittenVOE', Display: 'Written VOE' },
        { ID: 'Stated', Display: 'Stated' },
        { ID: 'OneYear1099', Display: '1099 - 12M' },
        { ID: 'TwoYear1099', Display: '1099 - 24M' },
        { ID: 'PLOneYear', Display: '12Mo P&L' },
        { ID: 'PLTwoYear', Display: '24Mo P&L' },
        { ID: 'NoIncomeVerification', Display: 'No Income Verification' }
    ];

    export const loanTypeList =  [
        { ID: "Conforming", Display: 'Conforming' },
        { ID: "NonConforming", Display: 'Non Conforming' },
        { ID: "FHA", Display: 'FHA' },
        { ID: "VA", Display: 'VA' },
        { ID: "Conventional", Display: 'Conventional' },
        { ID: "HELOC", Display: 'HELOC' },
        { ID: "USDARuralHousing", Display: 'USDA Rural Housing' }
    ]

    export const loanTermList = [
        { ID: 'ThreeMonth', Display: '3 mo' },
        { ID: 'SixMonth', Display: '6 mo' },
        { ID: 'NineMonth', Display: '9  mo' },
        { ID: 'OneYear', Display: '1 yr' },
        { ID: 'TwoYear', Display: '2 yr' },
        { ID: 'ThreeYear', Display: '3 yr' },
        { ID: 'FourYear', Display: '4 yr' },
        { ID: 'FiveYear', Display: '5 yr' },
        { ID: 'SixYear', Display: '6 yr' },
        { ID: 'SevenYear', Display: '7 yr' },
        { ID: 'EightYear', Display: '8 yr' },
        { ID: 'NineYear', Display: '9 yr' },
        { ID: 'TenYear', Display: '10 yr' },
        { ID: 'TwelveYear', Display: '12 yr' },
        { ID: 'FifteenYear', Display: '15 yr' },
        { ID: 'TwentyYear', Display: '20 yr' },
        { ID: 'TwentyFiveYear', Display: '25 yr' },
        { ID: 'ThirtyYear', Display: '30 yr' },
        { ID: 'FortyYear', Display: '40 yr' },
    ];

    export const amortizationTypeList =  [
        { ID: 'Fixed', Display: 'Fixed' },
        { ID: 'ARM', Display: 'Arm' },
        { ID: 'Balloon', Display: 'Balloon' },
        { ID: 'OptionArm', Display: 'Option Arm' }
    ];

    export const armFixedTermList = [
        { Display: '1 mo', ID: 'OneMonth'},
        { Display: '3 mo', ID: 'ThreeMonth'},
        { Display: '6 mo', ID: 'SixMonth'},
        { Display: '1 yr', ID: 'OneYear'},
        { Display: '2 yr', ID: 'TwoYear'},
        { Display: '3 yr', ID: 'ThreeYear'},
        { Display: '5 yr', ID: 'FiveYear'},
        { Display: '6 yr', ID: 'SixYear'},
        { Display: '7 yr', ID: 'SevenYear'},
        { Display: '10 yr', ID: 'TenYear'},
        { Display: '15 yr', ID: 'FifteenYear'}
    ]

    export const loanPurposeList = [
        { ID: 'Purchase', Display: 'Purchase' },
        { ID: 'RefiCashout', Display: 'Refi Cashout' },
        { ID: 'RefiRateTermLimitedCO', Display: 'Refi Rate-Term/Limited C.O.' },
        { ID: 'FHAStreamlineRefi', Display: 'FHA Streamline Refi' },
        { ID: 'VARateReduction', Display: 'VA Rate Reduction' },
        { ID: 'SimpleRefinance', Display: 'Simple Refinance' }
    ];

    export const lienTypeList =  [
        { ID: 'First', Display: 'First' },
        { ID: 'Second', Display: 'Second' }
    ];

    export const lienTypeListWithHELOC =  [
        { ID: 'HelocFirst', Display: 'First' },
        { ID: 'HelocSecond', Display: 'Second' }
    ];

    export const occupancyList =  [
        { ID: 'PrimaryResidence', Display: 'Primary Residence' },
        { ID: 'SecondHome', Display: 'Second Home' },
        { ID: 'InvestmentProperty', Display: 'Investment Property' },
    ];

    export const propertyTypeList = [
        { ID: 'SingleFamily', Display: 'Single Family' },
        { ID: 'Condo', Display: 'Condo' },
        { ID: 'PUD', Display: 'PUD' },
        { ID: 'Modular', Display: 'Modular' },
        { ID: 'NonWarrantableCondo', Display: 'Non-Warrantable Condo' },
        { ID: 'Condotel', Display: 'Condotel' },
        { ID: 'ManufacturedSingleWide', Display: 'Manufactured/Single-wide' },
        { ID: 'ManufacturedDoubleWide', Display: 'Manufactured/Double-wide' },
        { ID: 'Timeshare', Display: 'Timeshare' },
        { ID: 'Coop', Display: 'Coop' },
        { ID: 'Townhouse', Display: 'Townhouse' },
        { ID: 'DetachedCondo', Display: 'Detached Condo' }
    ];

    export const numberOfUnitsList =  [
        { ID: 'OneUnit', Display: '1 Unit' },
        { ID: 'TwoUnits', Display: '2 Units' },
        { ID: 'ThreeUnits', Display: '3 Units' },
        { ID: 'FourUnits', Display: '4 Units' },
    ];

    export const numberOfStories = [
        { ID: 0, Display: '1 Unit' },
        { ID: 1, Display: '2 Units' },
        { ID: 2, Display: '3 Units' },
        { ID: 3, Display: '4 Units' },
    ];

    export const attachmentType = [
        { ID: 'Attached', Display: 'Attached' },
        { ID: 'Detached', Display: 'Detached' },
        { ID: 'SemiDetached', Display: 'Semi-Detached' }
    ];

    export const housingEventTypeList = [
        { ID: 'DeedInLieu', Display: 'DeedInLieu' },
        { ID: 'Foreclosure', Display: 'Foreclosure' },
        { ID: 'Modification', Display: 'Modification' },
        { ID: 'None', Display: 'None' },
        { ID: 'ShortSale', Display: 'Short Sale' }
    ];

    export const housingEventSeasoningList = [
        { ID: 'Last1To12Months', Display: 'Last 1 To 12 mo' },
        { ID: 'Last13To24Months', Display: 'Last 13 To 24 mo' },
        { ID: 'Last25To36Months', Display: 'Last 25 To 36 mo' },
        { ID: 'Last37To48Months', Display: 'Last 37 To 48 mo' },
        { ID: 'Last49To60Months', Display: 'Last 49 To 60 mo' },
        { ID: 'MoreThanFiveYearsAgo', Display: '> 5 Years' },
        { ID: 'NotApplicable', Display: 'Not Applicable' }
    ];

    export const searchByList = [
        { ID: 'ByRate', Display: 'By Rate' },
        //{ ID: 'ByPrice_0', Display: 'By Price (0 PAR)' },  // removing this because it is confusing and not needed
        { ID: 'ByPrice_100', Display: 'By Price (100 PAR)' },
    ];

    export const borrowerPaidMIList = [
        { ID: 'Yes', Display: 'Borrower' },
        { ID: 'No', Display: 'Lender' }
    ];

    export const bankruptcyTypeList = [
        { ID: 'None', Display: 'None' },
        { ID: 'Chapter7', Display: 'Chapter 7' },
        { ID: 'Chapter11', Display: 'Chapter 11' },
        { ID: 'Chapter13', Display: 'Chapter 13' },
    ];

    export const bankruptcySeasoningList = [
        { ID: 'NotApplicable', Display: 'Not Applicable' },
        { ID: 'Last1To12Months', Display: '< 1 Year' },
        { ID: 'Last13To24Months', Display: '1-2 Years' },
        { ID: 'Last25To36Months', Display: '2-3 Years' },
        { ID: 'Last37To48Months', Display: '3-4 Years' },
        { ID: 'Last49To60Months', Display: '4-5 Years' },
        { ID: 'MoreThanFiveYearsAgo', Display: '5+ Years' },
    ];

    export const bankruptcyOutcomeList = [
        { ID: 'NotApplicable', Display: 'Not Applicable' },
        { ID: 'OpenOrPending', Display: 'Open or Pending' },
        { ID: 'Discharged', Display: 'Discharged' },
        { ID: 'Dismissed', Display: 'Dismissed' },
    ];

    export const buydownList = [
        { ID: 'None', Display: 'None' },
        { ID: 'ThreeTwoOne', Display: '3/2/1' },
        { ID: 'TwoOne', Display: '2/1' },
        { ID: 'OneZero', Display: '1/0' },
        { ID: 'OneOne', Display: '1/1' },
    ];

    export const prepaymentPenaltyList = [
        { ID: 'None', Display: 'None' },
        { ID: 'OneYear', Display: '1 Year' },
        { ID: 'TwoYear', Display: '2 Year' },
        { ID: 'ThreeYear', Display: '3 Year' },
        { ID: 'FourYear', Display: '4 Year' },
        { ID: 'FiveYear', Display: '5 Year' }
    ];

    export const zeroTo4PlusList = [
        { ID: '0', Display: '0' },
        { ID: '1', Display: '1' },
        { ID: '2', Display: '2' },
        { ID: '3', Display: '3' },
        { ID: '4', Display: '4+' },
    ];

    export const typeOfVeteran = [
        { ID: 'ActiveDuty', Display: 'Active Duty'},
        { ID: 'NationalGuardOrReserves', Display: 'National Guard or Reserves'}
    ];

    export const productTypeList = [
        { ID: 'StandardProducts', Display: 'Standard Products' },
        { ID: 'AffordableProducts', Display: 'Affordable Products' },
        { ID: 'HARP', Display: 'HARP' },
        { ID: 'HeroProducts', Display: 'Hero Products' },
        { ID: 'StudentLoanCORefi', Display: 'Student Loan CO Refi' },
        { ID: 'RenovationAndRehabilitation', Display: 'Renovation and Rehabilitation' },
        { ID: 'BondAndHFA', Display: 'Bond and HFA' },
        { ID: 'HUDspecialty', Display: 'HUD Specialty' },
        { ID: 'USDAStreamline', Display: 'USDA Streamline' },
        { ID: 'ExpandedGuidelines', Display: 'Expanded Guidelines' }
    ];

    export const ausList = [
        { ID: 'DU', Display: 'DU'},
        { ID: 'LP', Display: 'LP'},
        { ID: 'NotSpecified', Display: 'Not Specified'},
        { ID: 'InvestorAUS', Display: 'Investor AUS'},
        { ID: 'ManualTraditional', Display: 'Manual Traditional'},
    ]

    export const compPricingList = [
        { ID: 'YesLenderPaid', Display: 'Yes (Lender Paid)'},
        { ID: 'NoBuyerPaid', Display: 'No (Buyer Paid)'},
        { ID: 'NoLenderPaid', Display: 'No (LenderPaid; not included in pricing)'},
    ]
}